import {
  formatScheduleValue,
  type ScheduleValue,
} from '@/lib/crm/automations/scheduleValue';
import { cx } from '@/utils/cx';

export interface ScheduleValueLabelProps {
  value: ScheduleValue;
  fontSize?: 'xs' | 'table' | 'sm' | 'base' | 'lg';
  className?: string;
  /** Enable CSS truncation with ellipsis and title tooltip */
  truncate?: boolean;
}

const fontSizeClasses = {
  xs: 'text-xs',
  table: 'text-[13px]',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
};

/**
 * Display component for `automation_schedule` values — the same wording the
 * automation record's Schedule section uses, flattened to one line for table
 * cells and detail rows.
 */
export const ScheduleValueLabel: React.FC<ScheduleValueLabelProps> = ({
  value,
  fontSize = 'sm',
  className = '',
  truncate,
}) => {
  const text = formatScheduleValue(value);
  return (
    <span
      className={cx(
        fontSizeClasses[fontSize],
        truncate && 'truncate block',
        className
      )}
      title={truncate ? text : undefined}
    >
      {text}
    </span>
  );
};
